import Navbar from "../components/Navbar";
import InformationForm from "../components/InformationForm";
import ScrollToTop from "../components/ScrollToTop";



export const InfoPage = () => {
    return (
        <div className="InfoPage">
            <ScrollToTop />
            <Navbar getScrolled={true}/>
            <InformationForm />
        </div>
    );
}

export default InfoPage